import Projects from './src/pages/Projects.vue'
import ProjectDetail from './src/pages/ProjectDetail.vue'
import ProjectTable from './src/components/ProjectTable.vue'
import Popper from './src/components/Popper.vue'
import AddRadishDrawer from './src/components/AddRadishDrawer.vue'
import OnekeyMatchDrawer from './src/components/OnekeyMatchDrawer.vue'
import CvmatchLoading from './src/components/CvmatchLoading.vue'
import DrawerProjects from './src/components/DrawerProjects.vue'
import CommendReport from './src/pages/CommendReport.vue'
// import ReportMaker from './src/components/ReportMaker.vue'
import ReportMaker from './src/components/ReportMakerV2/ReportMaker.vue'
import ReportTemplateV2 from './src/components/ReportMakerV2/ReportTemplateV2.vue'
import FollowDrawer from './src/components/FollowDrawer.vue'
// import Notifier from './src/components/Notifier.vue'
import SalaryStatistics from './src/pages/SalaryStatistics.vue'
import Wechatfiles from './src/pages/Wechatfiles.vue'
import ProjectDetailEditor from './src/components/ProjectDetailEditor.vue'
import LinkFile from './src/dialog/LinkFileV3.vue'
import MergeRadishes from './src/dialog/MergeRadishes.vue'
import BaseSearchBarItem from './src/components/BaseSearchBarItem.vue'
import NewAddProject from './src/pages/AddProject.vue'
import NewProjectList from './src/pages/NewProjectList.vue'
import NewProjectProgressDialog from './src/components/projectProgress/NewProjectProgressDialog.vue'
import CompanyCateLog from './src/components/ProjectDetail20/CompanyCateLog.vue'
import ChooseCity from './src/components/CreateProject20/ChooseCity'

export {
  Projects,
  ProjectDetail,
  ProjectTable,
  Popper,
  AddRadishDrawer,
  OnekeyMatchDrawer,
  CvmatchLoading,
  DrawerProjects,
  CommendReport,
  ReportMaker,
  ReportTemplateV2,
  FollowDrawer,
  // Notifier,
  SalaryStatistics,
  Wechatfiles,
  ProjectDetailEditor,
  LinkFile,
  MergeRadishes,
  BaseSearchBarItem,
  NewAddProject,
  NewProjectList,
  NewProjectProgressDialog,
  CompanyCateLog,
  ChooseCity
}
